// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abd36b29","494":"9fae391d","781":"5b8cb557"}[chunkId] + ".chunk.js";
};